import React from 'react'

export default function AppHeader ({
  user,
  systems,
  system,
  onChangeSystem,
  onLogout,
  profileActionsOpen,
  setProfileActionsOpen
}) {
  const userOptionsLabel = `Hello, ${user.first_name || 'there.'}`;

  return (
    <div className="app-header">
      <div className="app-header-left"/>
      <div className="app-header-right" onClick={(e) => e.stopPropagation()}>
        <div className="app-header-alerts">
          <div className="app-header-alerts-button">
            <i className="icofont-clock-time"></i>
          </div>
        </div>
        <div className="app-header-profile">
          <div
            className={`app-header-profile-name ${profileActionsOpen ? 'active' : ''}`}
            onClick={() => setProfileActionsOpen(!profileActionsOpen)}
          >
            <span>{userOptionsLabel}</span>
            <span className="material-symbols-outlined material-icons">expand_more</span>
          </div>
          {profileActionsOpen && (
            <div className="app-header--profile-actions">
              <div className="app-header--profile-actions-panel">
                <h4 style={{ padding: 10 }}>systems</h4>
                <ul>
                  {systems.map((s) => (
                    <li key={s.id}>
                      {s.id === system.id ? (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <div><div
                            style={{ width: 10, height: 10, borderRadius: '50%', background: '#409F1D' }}></div></div>
                          {s.resource.name}
                        </span>
                      ) : (
                        <a
                          href={'/'}
                          className={'app-header-link'}
                          style={{ display: 'flex', alignItems: 'center', gap: 10 }}
                          onClick={(e) => {
                            e.preventDefault()
                            onChangeSystem(s)
                          }}
                        >
                          <div>
                            <div style={{
                              width: 10,
                              height: 10,
                              borderRadius: '50%',
                              background: 'transparent',
                              border: 'solid #ccc 1px'
                            }}></div>
                          </div>
                          {s.resource.name}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="app-header--profile-actions-panel">
                <h4 style={{ padding: 10 }}>Account Actions</h4>
                <ul>
                  <li><a href="/account">Account Settings</a></li>
                  {system.is_owner &&
                    <li><a href="/account/payment-settings">Payment Settings</a></li>}
                </ul>
              </div>
              <div className="app-header--profile-actions-panel">
                <ul>
                  <li><a href={"/"} onClick={onLogout}>Log out</a></li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
};